import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6d53037e&scoped=true"
import script from "./index.vue?vue&type=script&lang=jsx"
export * from "./index.vue?vue&type=script&lang=jsx"
import style0 from "./index.vue?vue&type=style&index=0&id=6d53037e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d53037e",
  null
  
)

export default component.exports